import { Reveal } from "./Reveal";

export const ComingSoon = () => (
  <section className="bg-butter text-ink py-24 sm:py-32 border-t-2 border-ink" data-testid="coming-soon">
    <div className="mx-auto max-w-6xl px-5 sm:px-8 grid md:grid-cols-12 gap-10 items-center">
      <Reveal className="md:col-span-7">
        <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-ink/70">Book one of many</p>
        <h2 className="mt-4 font-display text-5xl sm:text-6xl leading-[0.95]">More stories are on the way.</h2>
        <p className="mt-6 text-base sm:text-lg text-ink/80 max-w-lg">
          The Party Pet Shop is Reuben's first book. He's already dreaming up the next adventure, so keep checking back!
        </p>
      </Reveal>
      <Reveal delay={0.15} className="md:col-span-5">
        <div className="flex gap-4 justify-center md:justify-end">
          {["?", "?"].map((q, i) => (
            <div key={i} className={`w-28 sm:w-36 aspect-[3/4] rounded-r-2xl rounded-l-md border-2 border-dashed border-ink grid place-items-center font-display text-6xl text-ink/40 bg-cream/50 ${i ? "rotate-6" : "-rotate-6"} hover:rotate-0 transition-transform duration-500`}>
              {q}
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
